import donnees from './donnees/blocages.json';

interface EntreeBlocage {
  libelle: string;
  actionDetective: boolean;
  mention?: string;
}
const TABLE = donnees.blocages as Readonly<Record<string, EntreeBlocage>>;

export const VERSION_BLOCAGES: string = donnees.version;

/** Un code brut du serveur : minuscules, chiffres et tirets bas, sans espace. */
const estCodeBrut = (texte: string): boolean => /^[a-z0-9_]+$/.test(texte);

export interface BlocagePresente {
  libelle: string;
  actionDetective: boolean;
  mention: string | null;
}

/**
 * Libellé français d'un blocage, tiré de la donnée versionnée `donnees/blocages.json`. Un libellé déjà rédigé par
 * le serveur est conservé ; un code brut n'est jamais affiché (code inconnu : libellé générique neutre).
 */
export function presenterBlocage(blocage: { kind: string; label: string }): BlocagePresente {
  const entree = Object.hasOwn(TABLE, blocage.kind) ? TABLE[blocage.kind] : undefined;
  const redige = !estCodeBrut(blocage.label.trim());
  return {
    libelle: redige ? blocage.label : (entree?.libelle ?? donnees.generique),
    actionDetective: entree?.actionDetective === true,
    mention: entree?.mention ?? null,
  };
}
